import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo1.png';
import './components.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const NavbarToggler = () => {
  return (
    <nav className="navbar bg-light fixed-top navbar-expand-sm p-3" style={{borderBottom:"0px solid hsl(255, 93%, 30%)"}}>
      
      <div className="container-fluid">
        <a className="navbar-brand" href="#home">
          <img src={logo} alt="buildfortune construction" height="40px" width="30px" />
        </a>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navmenu"
          style={{ backgroundColor: 'hsl(255, 93%, 30%)',marginRight: '10px'}}
        >
          <span className="text-light">☰</span>
        </button>
        <div className="collapse navbar-collapse" id="navmenu" >
          <ul className="navbar-nav ms-auto " style={{ letterSpacing: '1px', textAlign: 'center',fontSize:'14px'}}>
            <li className="nav-item active">
              <a href="#aboutUs" target="_parent" style={{color:'hsl(255, 93%, 30%)',fontWeight:"500",textDecoration:'none',paddingRight:'12px',letterSpacing:'1px'}} >ABOUT</a>
            </li>
            <li className="nav-item">
              <a href="#features" target="_parent" style={{color:'hsl(255, 93%, 30%)',fontWeight:"500",textDecoration:'none',paddingRight:'12px',letterSpacing:'1px'}}>FEATURES</a>
            </li>
            <li className="nav-item">
              <a href="#projects" target="_parent" style={{color:'hsl(255, 93%, 30%)',fontWeight:"500",textDecoration:'none',paddingRight:'12px',letterSpacing:'1px'}}>PROJECTS</a>
            </li>
            <li className="nav-item">
              <a href="#howwework" target="_parent" style={{color:'hsl(255, 93%, 30%)',fontWeight:"500",textDecoration:'none',paddingRight:'12px',letterSpacing:'1px'}}>HOW WE WORK</a>
            </li> 
            <li className="nav-item">
              <a href="#contactUs" target="_parent" style={{color:'hsl(255, 93%, 30%)',fontWeight:"500",textDecoration:'none',paddingRight:'12px',letterSpacing:'1px'}}>CONTACT US</a>
            </li> 
          </ul>
         
        </div>
        <div className="navbar-header" style={{ backgroundColor: 'rgb(134, 198, 39)', padding: '6px' }}>
        <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: 'white' }} />
          <span style={{ color: 'white', marginLeft: '10px' }}>Karnataka | Bengaluru</span>
          <FontAwesomeIcon icon={faMobileAlt} style={{ color: 'white',marginLeft: '20px' }} />
          <span style={{ color: 'white', marginLeft: '10px' }}>9740890386 | 8217210038</span>
        </div>
      </div>
     
    </nav>
  );
}

export default NavbarToggler;
